import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Grid } from '@mui/material';
import { Provider } from 'models';
import { getDocumentsFolderForUserId } from './DocumentShared';
import { Colors } from 'library/theme';
import { useUserContext } from 'UserContext';
import DocumentDownloadInfo from 'parent-portal/jobs/upcoming/BusinessCalendar/ShiftCard/DocumentDownloadInfo';
import { LoadingIndicator } from 'library';

export default function DownloadAllDocuments({ provider }: { provider: Provider }) {
    const { user } = useUserContext();
    const [showDocDownloadInfo, setShowDocDownloadInfo] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const showModal = () => {
        if (user?.address?.[0]?.state === 'Illinois') setShowDocDownloadInfo(!!provider.needs_718b_filing);
    };

    const setLoadingFalse = () => {
        setIsDownloading(false);
    };

    function download() {
        setIsDownloading(true);
        getDocumentsFolderForUserId(provider.user.id, showModal, setLoadingFalse);
    }
    return (
        <>
            <Grid onClick={download} style={{ cursor: 'pointer' }}>
                {isDownloading ? <LoadingIndicator /> : <DownloadIcon htmlColor={Colors.darkNavy} />}
            </Grid>
            <DocumentDownloadInfo
                showDocDownloadInfo={showDocDownloadInfo}
                setShowDocDownloadInfo={setShowDocDownloadInfo}
            />
        </>
    );
}
